import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { initializeLoaderExperience } from '~loader/initializeLoaderExperience';
import { RecentProjects } from '~src/components/Projects';
import { isFeatureEnabled } from '~src/features';
import { getUser } from '~src/user';

const SELECTORS = {
  createButton: '.dashboard-sidebar__create',
  startLink: '#home-link-start',
  sidebarToggle: '.dashboard-sidebar-toggle',
  sidebarBackdrop: '.dashboard-sidebar-backdrop',
  sidebar: '.dashboard-sidebar',
  overlay: '#home-create-modal',
  overlayBackdrop: '.home-create-modal__overlay',
  closeButton: '#home-create-modal-close',
  loaderContainer: '#route-loader',
};

let isModalOpen = false;
let isLoading = false;

const closeResponsiveSidebar = () => {
  $('body').removeClass('dashboard-sidebar-open');
  $(SELECTORS.sidebarToggle).attr('aria-expanded', 'false');
};

const openResponsiveSidebar = () => {
  $('body').addClass('dashboard-sidebar-open');
  $(SELECTORS.sidebarToggle).attr('aria-expanded', 'true');
};

const resetModalState = () => {
  $('body').removeClass('home-create-modal-open sidebar-context-locked');
  $(SELECTORS.overlay).removeClass('is-open').attr('aria-hidden', 'true');
  $(SELECTORS.loaderContainer).removeClass('home-create-modal__content').hide();
  isModalOpen = false;
  isLoading = false;
};

const closeModal = () => {
  if (!isModalOpen && !isLoading) {
    return;
  }

  resetModalState();
};

// Expose a safe helper so other modules can close the Create modal when needed
export const closeHomeCreateModal = () => {
  if (
    isModalOpen ||
    isLoading ||
    document.body.classList.contains('home-create-modal-open')
  ) {
    resetModalState();
  }
};

const openModal = async () => {
  if (isModalOpen || isLoading) {
    return;
  }

  isLoading = true;
  closeResponsiveSidebar();
  const $scope = $('.editor-route:visible');
  $scope
    .find('#dashboard-sidebar-profile-menu')
    .removeClass('is-open')
    .attr('aria-hidden', 'true');
  $scope
    .find('#dashboard-sidebar-profile-trigger')
    .attr('aria-expanded', 'false');

  $('body').addClass('home-create-modal-open sidebar-context-locked');
  $(SELECTORS.overlay).addClass('is-open').attr('aria-hidden', 'false');
  const $loader = $(SELECTORS.loaderContainer);
  $loader.addClass('home-create-modal__content').show();

  try {
    await initializeLoaderExperience({ inModal: true });
    isModalOpen = true;
  } catch (error) {
    console.error('Impossibile aprire il pannello Crea', error);
    resetModalState();
  } finally {
    isLoading = false;
  }
};

const bindEvents = () => {
  $(SELECTORS.createButton)
    .off('click.homeCreate')
    .on('click.homeCreate', (event) => {
      event.preventDefault();
      openModal();
    });

  $(SELECTORS.closeButton)
    .off('click.homeCreate')
    .on('click.homeCreate', (event) => {
      event.preventDefault();
      closeModal();
    });

  // Handle Home hero CTA "Inizia a creare"
  $(SELECTORS.startLink)
    .off('click.homeCreate')
    .on('click.homeCreate', (event) => {
      event.preventDefault();
      // Prevent Navigo from intercepting the link
      event.stopPropagation();
      openModal();
    });

  // Close when clicking on the modal backdrop (overlay)
  $(SELECTORS.overlayBackdrop)
    .off('click.homeCreate')
    .on('click.homeCreate', (event) => {
      // If clicking where the profile trigger sits, close modal and then open profile menu
      try {
        const $trigger = $('#dashboard-sidebar-profile-trigger');
        if ($trigger.length) {
          const rect = $trigger[0].getBoundingClientRect();
          const x = event.clientX;
          const y = event.clientY;
          const withinTrigger =
            typeof x === 'number' &&
            typeof y === 'number' &&
            x >= rect.left &&
            x <= rect.right &&
            y >= rect.top &&
            y <= rect.bottom;

          closeModal();

          if (withinTrigger) {
            // Defer to ensure classes/styles are updated before opening the menu
            setTimeout(() => {
              $trigger.trigger('click');
            }, 0);
          }
          return;
        }
      } catch (e) {
        // non-blocking; fallback to simple close
      }
      closeModal();
    });

  $(document)
    .off('keydown.homeCreate')
    .on('keydown.homeCreate', (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
};

const setupResponsiveSidebar = () => {
  const $toggle = $(SELECTORS.sidebarToggle);
  const $backdrop = $(SELECTORS.sidebarBackdrop);
  const $sidebar = $(SELECTORS.sidebar);

  if (!$toggle.length || !$sidebar.length) {
    return;
  }

  closeResponsiveSidebar();

  $toggle
    .off('click.homeSidebarToggle')
    .on('click.homeSidebarToggle', (event) => {
      event.preventDefault();
      if ($('body').hasClass('dashboard-sidebar-open')) {
        closeResponsiveSidebar();
      } else {
        openResponsiveSidebar();
      }
    });

  $backdrop
    .off('click.homeSidebarBackdrop')
    .on('click.homeSidebarBackdrop', (event) => {
      event.preventDefault();
      closeResponsiveSidebar();
    });

  $('body')
    .off('click.homeSidebarNav')
    .on(
      'click.homeSidebarNav',
      '.dashboard-sidebar__nav-item, .dashboard-sidebar__profile-trigger',
      () => {
        if (window.innerWidth <= 992) {
          closeResponsiveSidebar();
        }
      }
    );

  $(window)
    .off('resize.homeSidebar')
    .on('resize.homeSidebar', () => {
      if (window.innerWidth > 992) {
        closeResponsiveSidebar();
      }
    });
};

// Highlight active sidebar item based on current route
const setActiveSidebarItem = () => {
  try {
    const $scope = $('.editor-route:visible');
    if (!$scope.length) return;

    const path = window.location?.pathname || '/';
    const routes = [
      { test: /^\/$/, id: '#dashboard-sidebar-home' },
      { test: /^\/projects(\/.*)?$/, id: '#dashboard-sidebar-projects' },
      { test: /^\/products(\/.*)?$/, id: '#dashboard-sidebar-products' },
      { test: /^\/ai(\/.*)?$/, id: '#dashboard-sidebar-ai' },
    ];

    $scope.find('.dashboard-sidebar__nav-item').removeClass('is-active');
    const match = routes.find((r) => r.test.test(path));
    if (match) {
      $scope.find(match.id).addClass('is-active');
    }
  } catch (e) {
    // non-blocking
  }
};

// Show/hide Products nav item based on feature flag
const toggleProductsMenuByFeature = async () => {
  try {
    const $scope = $('.editor-route:visible');
    if (!$scope.length) return;
    const enabled = await isFeatureEnabled('giotto.show_products');
    const $item = $scope.find('#dashboard-sidebar-products');
    if (!$item.length) return;
    if (enabled) {
      $item.show();
    } else {
      $item.hide();
    }
  } catch (e) {
    // non-blocking
  }
};

const renderRecentProjects = async () => {
  const container =
    document.querySelector('#home-recent-projects') ||
    document.querySelector('#projects-recent-projects');

  if (!container) {
    return;
  }

  ReactDOM.unmountComponentAtNode(container);
  container.innerHTML =
    '<div class="home-recent-projects__placeholder text-center text-muted w-100">Caricamento dei progetti…</div>';

  try {
    const { user } = await getUser();
    const isGlobalEditor = user?.giottoGlobalAdmin === true;

    if (isGlobalEditor) {
      container.innerHTML =
        '<p class="text-center text-muted w-100 my-4">Nessun progetto recente disponibile.</p>';
      return;
    }

    container.innerHTML = '';
    ReactDOM.render(React.createElement(RecentProjects), container);
  } catch (error) {
    console.error('Impossibile caricare i progetti recenti', error);
    container.innerHTML =
      '<p class="text-center text-danger w-100 my-4">Errore durante il caricamento dei progetti.</p>';
  }
};

// Render a small greeting above the Home title
const renderGreeting = async () => {
  try {
    const headline = document.querySelector('.home-hero__headline');
    if (!headline) return;

    const el = headline.querySelector('#home-greeting');
    if (!el) return;

    const { user } = await getUser();
    const firstName =
      user?.first_name || user?.firstName || user?.username || '';
    if (!firstName) {
      el.style.display = 'none';
      return;
    }

    el.textContent = `Bentornato/a in Giotto, ${firstName}`;
  } catch (e) {
    // non-blocking
    // eslint-disable-next-line no-console
    console.warn('Impossibile mostrare il saluto', e);
  }
};

/**
 * If the URL contains ?ref=beta, show a small appreciation banner
 * above the Home hero section. Rendered only once per route load.
 */
const maybeShowBetaBanner = () => {
  try {
    const hero = document.querySelector('.home-hero');
    if (!hero) {
      return; // Not on home layout
    }

    const params = new URLSearchParams(window.location.search);
    const isBetaRef = params.get('ref') === 'beta';
    const alreadyRendered = document.getElementById('home-beta-banner');

    if (!isBetaRef || alreadyRendered) {
      return;
    }

    const banner = document.createElement('div');
    banner.id = 'home-beta-banner';
    banner.className = 'home-beta-banner';
    banner.setAttribute('role', 'region');
    banner.setAttribute('aria-label', 'Grazie per aderire al programma beta');
    banner.innerHTML = `
      <div class="home-beta-banner__content">
        <strong>Grazie per aver aderito al programma beta!</strong>
        <span class="home-beta-banner__text">
          Hai accesso anticipato alle nuove funzionalità di Giotto. Il tuo feedback è prezioso.
        </span>
      </div>
    `;

    hero.parentNode.insertBefore(banner, hero);
  } catch (e) {
    // Non-blocking: if parsing or DOM insertion fails, continue silently
    // eslint-disable-next-line no-console
    console.warn('Impossibile mostrare il banner beta', e);
  }
};

export const initHomeExperience = () => {
  resetModalState();
  bindEvents();
  setupResponsiveSidebar();
  setActiveSidebarItem();
  // Fire-and-forget; no need to block init
  toggleProductsMenuByFeature();
  renderRecentProjects();
  renderGreeting();
  maybeShowBetaBanner();

  // If requested via query string, open the Create modal automatically
  try {
    const url = new URL(window.location.href);
    const openCreate = url.searchParams.get('openCreate');
    if (openCreate === '1' || openCreate === 'true') {
      // Remove the param from the URL to avoid reopening on refresh
      url.searchParams.delete('openCreate');
      window.history.replaceState({}, document.title, url.toString());
      // Open the modal
      // Delay slightly to ensure DOM and bindings are ready
      setTimeout(() => {
        // Open using the same logic as the sidebar "Crea" button
        const $btn = $(SELECTORS.createButton);
        if ($btn.length) {
          $btn.trigger('click');
        } else {
          // Fallback to direct open
          openModal();
        }
      }, 0);
    }
  } catch (e) {
    // non-blocking
  }
};
